import { GetServerSidePropsContext } from 'next'
import { cookies } from 'next/headers'
import nookies, { parseCookies, setCookie, destroyCookie } from 'nookies'
import { ParsedUrlQuery } from 'querystring'
import { accessTokenKey, refreshTokenKey } from './constants'

interface TokenServiceProps {
  write: (ctx: CtxType | undefined, token: string) => void
  read: (ctx?: CtxType) => string | undefined
  delete: (ctx?: CtxType) => void
}

type CtxType = GetServerSidePropsContext<ParsedUrlQuery>
export const accessToken: TokenServiceProps = {
  write: (ctx: CtxType, token) =>
    setCookie(ctx, accessTokenKey, token, { path: '/' }),
  read: (ctx?: CtxType) => parseCookies(ctx)[accessTokenKey],
  delete: (ctx?: CtxType) => destroyCookie(ctx, accessTokenKey, { path: '/' }),
}

export const refreshToken: TokenServiceProps = {
  write: (ctx: CtxType, token) =>
    setCookie(ctx, refreshTokenKey, token, { path: '/' }),
  read: (ctx?: CtxType) => parseCookies(ctx)[refreshTokenKey],
  delete: (ctx?: CtxType) =>
    nookies.destroy(ctx, refreshTokenKey, { path: '/' }),
}
